import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { HeaderOptionsService } from './header-options.service';

@Injectable({
  providedIn: 'root'
})
export class LicencasService {

  constructor(private http: HttpClient,
    private headerOptionsService: HeaderOptionsService
  ) { }
  
  baseUrl = environment.baseUrl;

  cadastrarLicenca(licenca: any){
    const url = `${this.baseUrl}cadastrarLicenca`;
    return this.http.post<any>(url, licenca);
  }

  listarLicenca(){
    const url = `${this.baseUrl}listarLicenca`;
    return this.http.get<any>(url);
  }

  listarLicencaComCampos(){
    const url = `${this.baseUrl}listarLicencaComCampos`;
    return this.http.get<any>(url);
  }

  adquirirLicenca(dadosLicencaCliente: any){
    const url = `${this.baseUrl}adquirirLicenca`;
    return this.http.post<any>(url, dadosLicencaCliente);
  }

  listarLicencaAdquiridaPorIdOuIdEClienteComDadosUsuariosOrdenadoPeloId(params: any, idCliente: string, idLicenca: string): Observable<any>{
    const url = `${this.baseUrl}listarLicencaAdquiridaPorIdOuIdEClienteComDadosUsuariosOrdenadoPeloId/${idLicenca}${idCliente != '0' ? '/' + idCliente : ''}`;
    var headerOption = this.headerOptionsService.getHttpOptions();
    headerOption.params = {
      'page': params.page
    }
    return this.http.get<any>(url, headerOption);
  }

  listarLicencaAdquiridaPorClienteComDadosUsuariosOrdenadoPeloId(idCliente: string, idLicenca: string): Observable<any>{
    const url = `${this.baseUrl}listarLicencaAdquiridaPorClienteComDadosUsuariosOrdenadoPeloId/${idLicenca}${idCliente != '0' ? '/' + idCliente : ''}`;
    return this.http.get<any>(url);
  }

  cancelarLicencaAdquirirda(idLicencaAdquirida: any, alvoTecnico: any){
    const url = `${this.baseUrl}cancelarLicenca/${idLicencaAdquirida}`;
    return this.http.put<any>(url, alvoTecnico);
  }

  alterarLicencaAdquirirda(idLicencaAdquirida: any, tipoAlteracao: any, dadosLicencaCliente: any){
    const url = `${this.baseUrl}alterarLicencaAdquirida/${idLicencaAdquirida}/${tipoAlteracao}`;
    return this.http.put<any>(url, dadosLicencaCliente);
  }

  enviarParaEmail(dadosParEnviarPorEmail: any){
    const url = `${this.baseUrl}enviarParaOEmail`;
    return this.http.post<any>(url, dadosParEnviarPorEmail);
  }
  
  listarQntDeLicencasAdquiridasAcoes(idLicenca: any, idCliente?: any){
    const url = `${this.baseUrl}listarQntDeLicencasAdquiridasAcoes/${idLicenca}${idCliente != '0' ? '/' + idCliente : ''}`;
    return this.http.get<any>(url);
  }

  listarLicencaAdquiridaPorStatusComClienteComDadosUsuariosPaginadoOrdenadoPeloId(params: any, idLicenca: string, status: string, idCliente?: string): Observable<any>{
    const url = `${this.baseUrl}listarLicencaAdquiridaPorStatusComClienteComDadosUsuariosPaginadoOrdenadoPeloId/${idLicenca}/${status}${idCliente != '0' ? '/' + idCliente : ''}`;
    var headerOption = this.headerOptionsService.getHttpOptions();
    headerOption.params = {
      'page': params.page
    }
    return this.http.get<any>(url, headerOption);
  }
}
